import { SCOREKEEPER_BRAND_ASSETS } from '../lib/brandAssets';

type LogoLockup = 'horizontal' | 'primary' | 'rotated';

interface ScorekeeperLogoProps {
  lockup?: LogoLockup;
  alt?: string;
  className?: string;
}

const LOCKUP_SRC: Record<LogoLockup, { light: string; dark: string }> = {
  horizontal: {
    light: SCOREKEEPER_BRAND_ASSETS.logoHorizontalLight,
    dark: SCOREKEEPER_BRAND_ASSETS.logoHorizontalDark,
  },
  primary: {
    light: SCOREKEEPER_BRAND_ASSETS.logoPrimaryLight,
    dark: SCOREKEEPER_BRAND_ASSETS.logoPrimaryDark,
  },
  rotated: {
    light: SCOREKEEPER_BRAND_ASSETS.logoRotatedLight,
    dark: SCOREKEEPER_BRAND_ASSETS.logoRotatedDark,
  },
};

export function ScorekeeperLogo({ lockup = 'horizontal', alt = 'The Scorekeeper', className = '' }: ScorekeeperLogoProps) {
  const src = LOCKUP_SRC[lockup];

  return (
    <span className={`scorekeeper-logo ${className}`.trim()} role={alt ? 'img' : undefined} aria-label={alt || undefined}>
      <img className="scorekeeper-logo__img scorekeeper-logo__img--light" src={src.light} alt="" aria-hidden />
      <img className="scorekeeper-logo__img scorekeeper-logo__img--dark" src={src.dark} alt="" aria-hidden />
    </span>
  );
}

export function ScorekeeperIcon({ className = '', alt = '' }: { className?: string; alt?: string }) {
  return <img className={`scorekeeper-icon ${className}`.trim()} src={SCOREKEEPER_BRAND_ASSETS.icon512} alt={alt} />;
}
